import { LOCAL_STORAGE_KEY } from "../../assets/styles/constants";

export function getInitialLanguage() {
  const supportedLanguages = ['en', 'tr'];
  const defaultLanguage = 'en';

  const storedLang = localStorage.getItem(LOCAL_STORAGE_KEY.LANGUAGE);
  if (storedLang && supportedLanguages.includes(storedLang)) {
    return storedLang;
  }

  const browserLang = navigator.language.split(/[-_]/)[0];
  if (browserLang === 'tr') {
    return 'tr';
  }

  return defaultLanguage;
}

const languageConfig = {
  defaultLanguage: 'en',
  supportedLanguages: ['en', 'tr'],
  getInitialLanguage
};

export default languageConfig;
